"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTheme = void 0;

var createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));

var lodash_1 = require("lodash");

var themes_1 = require("./themes");

var util_1 = require("./util");

var createTheme = function createTheme(options) {
  var _a, _b;

  var baseMergedOptions = lodash_1.merge({}, themes_1.unifiBaseTheme, options);

  if (baseMergedOptions && options) {
    var mergedPrimary = (_a = baseMergedOptions === null || baseMergedOptions === void 0 ? void 0 : baseMergedOptions.palette) === null || _a === void 0 ? void 0 : _a.primary;
    var mergedSecondary = (_b = baseMergedOptions === null || baseMergedOptions === void 0 ? void 0 : baseMergedOptions.palette) === null || _b === void 0 ? void 0 : _b.secondary;
    var primary;
    var secondary;

    if (options.palette) {
      primary = options.palette.primary;
      secondary = options.palette.primary;
    }

    if (primary && primary.main) {
      if (!primary.dark && mergedPrimary) {
        delete mergedPrimary['dark'];
      }

      if (!primary.light && mergedPrimary) {
        delete mergedPrimary['light'];
      }
    }

    if (secondary && secondary.main) {
      if (!secondary.dark && mergedSecondary) {
        delete mergedSecondary['dark'];
      }

      if (!secondary.light && mergedSecondary) {
        delete mergedSecondary['light'];
      }
    }
  }

  var mergedBaseTheme = createMuiTheme_1.default(baseMergedOptions);
  var mergedTheme = {
    overrides: {
      MuiButton: {
        containedPrimary: {},
        containedSecondary: {},
        outlinedPrimary: {},
        outlinedSecondary: {}
      },
      MuiFab: {
        primary: {},
        secondary: {}
      }
    }
  };

  if (mergedBaseTheme && options) {
    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiButton || options.overrides && options.overrides.MuiButton && !options.overrides.MuiButton.containedPrimary) {
      mergedTheme.overrides.MuiButton.containedPrimary['&:focus'] = {
        boxShadow: "0 0 0 4px " + util_1.darken(mergedBaseTheme.palette.primary.main, 0.4)
      };
    }

    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiButton || options.overrides && options.overrides.MuiButton && !options.overrides.MuiButton.containedSecondary) {
      mergedTheme.overrides.MuiButton.containedSecondary['&:focus'] = {
        boxShadow: "0 0 0 4px " + util_1.darken(mergedBaseTheme.palette.secondary.main, 0.4)
      };
    }

    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiButton || options.overrides && options.overrides.MuiButton && !options.overrides.MuiButton.outlinedPrimary) {
      mergedTheme.overrides.MuiButton.outlinedPrimary = {
        borderColor: util_1.fade(mergedBaseTheme.palette.primary.main, 0.8)
      };
    }

    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiButton || options.overrides && options.overrides.MuiButton && !options.overrides.MuiButton.outlinedSecondary) {
      mergedTheme.overrides.MuiButton.outlinedSecondary = {
        borderColor: util_1.fade(mergedBaseTheme.palette.secondary.main, 0.8)
      };
    }

    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiFab || options.overrides && options.overrides.MuiFab && !options.overrides.MuiFab.primary) {
      mergedTheme.overrides.MuiFab.primary['&:focus'] = {
        boxShadow: "0 0 0 4px " + util_1.darken(mergedBaseTheme.palette.primary.main, 0.4)
      };
    }

    if (!options || options && !options.overrides || options.overrides && !options.overrides.MuiFab || options.overrides && options.overrides.MuiFab && !options.overrides.MuiFab.secondary) {
      mergedTheme.overrides.MuiFab.secondary['&:focus'] = {
        boxShadow: "0 0 0 4px " + util_1.darken(mergedBaseTheme.palette.secondary.main, 0.4)
      };
    }
  }

  return lodash_1.merge({}, mergedBaseTheme, mergedTheme);
};

exports.createTheme = createTheme;